import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "spinner-wrapper" },
    [
      _c(VProgressLinear, { attrs: { indeterminate: "" } }),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("general.loadingMessage")))]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }